import { GetDocument, UpdateDocument } from '@gohighlevel/ghl-proposals-common'

import config from '@/config'
import { requestsV2 } from '.'

export const DocumentServices = {
  getDocument: (params: GetDocument) =>
    requestsV2(config.PROPOSAL_SERVICE_URL).get(`/templates/${params.id}`, {
      params: { locationId: params.locationId },
    }),
  updateDocument: (params: UpdateDocument) => {
    const { id, ...rest } = params
    return requestsV2(config.PROPOSAL_SERVICE_URL).put(`/templates/${id}`, rest)
  },
  removeDocument: (id: string) =>
    requestsV2(config.PROPOSAL_SERVICE_URL).delete(`/templates/${id}`),

  convertToProposals: (locationId: string, id: string, locale: string) =>
    requestsV2(config.PROPOSAL_SERVICE_URL).post(
      `/templates/to-proposal/${locationId}/${id}?locale=${locale}`
    ),
  getAllCustomVariables: (locationId: string, templateId: string) =>
    requestsV2(config.PROPOSAL_SERVICE_URL).get<Record<string, string>>(
      `/templates/custom-values/${locationId}/${templateId}`
    ),
  getPublicTemplate: (params: { id: string }) =>
    requestsV2(config.PROPOSAL_SERVICE_URL).get(`/templates/public/getOne`, {
      params,
    }),
  publishDocForm: (
    locationId: string,
    templateId: string,
    publish: boolean
  ) => {
    return requestsV2(config.PROPOSAL_SERVICE_URL).post(`/templates/publish`, {
      locationId,
      templateId,
      publish,
    })
  },

  unpublishDocForm: (locationId: string, templateId: string) => {
    return requestsV2(config.PROPOSAL_SERVICE_URL).post(
      `/templates/unpublish`,
      {
        locationId,
        templateId,
      }
    )
  },

  getContentLibraryCustomContentCount: (params: { locationId: string }) =>
    requestsV2(config.PROPOSAL_SERVICE_URL).get(
      '/templates/content-library/custom-content-count',
      { params }
    ),
}
